import React, { useRef } from "react";
import { ReactComponent as CameraIcon } from "images/camera.svg";
import Button from "ui/Button";

import styled from "styled-components/macro";
import { theme } from "ui/theme";
import { AvatarSize } from "ui/eds/Avatar";

// TODO: Remove size prop after updating Student profile page. At that point, XL will be the default size.
export const $UploaderContainer = styled.div<{ $size: string }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  border-radius: 50%;
  background: ${theme.ColorBlurple100};
  clip-path: circle(calc(${({ $size }) => $size} / 2) at center);
`;

const $Button = styled(Button)`
  border-radius: 50%;
  height: 5.75rem;
  width: 5.75rem;

  &:hover {
    svg path {
      fill: ${theme.ColorSpace500};
    }
  }
  svg path {
    fill: ${theme.ColorSpace500};
  }

  &:focus-visible {
    outline: revert !important;
  }
`;

export interface InitialProfileImageUploaderProps {
  onFileInputChange: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
  size?: string;
}

// TODO: Remove size prop after updating Student profile page. At that point, XL will be the default size.
function InitialProfileImageUploader({
  onFileInputChange,
  size = AvatarSize.xxl,
}: InitialProfileImageUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  function onClick() {
    fileInputRef.current?.click();
  }

  return (
    <$UploaderContainer $size={size}>
      <$Button
        analyticsName="opened_image_upload"
        variant="link"
        aria-label="Upload profile picture"
        requestInProgress={false}
        isOnDarkBackground
        onClick={onClick}
      >
        <CameraIcon aria-hidden="true" focusable="false" role="img" />
      </$Button>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label aria-hidden="true">
        <input
          ref={fileInputRef}
          type="file"
          id="img-upload"
          accept="image/png, image/jpeg, image/jpg"
          className="visually-hidden"
          tabIndex={-1}
          onChange={(event) => onFileInputChange(event)}
        />
      </label>
    </$UploaderContainer>
  );
}

export default InitialProfileImageUploader;
